import React, { Component } from "react";
import T from "prop-types";

import { FieldTitle } from "react-admin";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import Checkbox from "@material-ui/core/Checkbox";
import Drawer from "@material-ui/core/Drawer";

export const EXCLUDE = -1;

export const ColumnSelectionForm = (props) => {
	const { columns, selection, resource, filterColumns, formGroupProps = {} } = props;

	const onColumnClicked = ({ target: { value: columnName } }) => {
		props.onColumnClicked(columnName);
	};

	// Apply filtering if filterColumns prop exists
	const filteredColumns = filterColumns
		? columns.filter(({ name }) => filterColumns.includes(name))
		: columns;

	return (
		<FormGroup {...formGroupProps}>
			{filteredColumns.map(({ source, label }) => (
				<FormControlLabel
					key={source}
					control={
						<Checkbox
							checked={selection[source] !== EXCLUDE}
							onChange={onColumnClicked}
							value={source}
						/>
					}
					label={<FieldTitle label={label} source={source} resource={resource} />}
				/>
			))}
		</FormGroup>
	);
};

ColumnSelectionForm.propTypes = {
	columns: T.arrayOf(
		T.shape({
			label: T.string,
			source: T.string.isRequired,
		})
	).isRequired,
	selection: T.object.isRequired,
	onColumnClicked: T.func.isRequired,
	resource: T.string.isRequired,
	filterColumns: T.arrayOf(T.string), // Optional prop
};

export const SelectionDialog = (props) => {
	const { columns, selection, onClose, resource, configurationLabel, filterColumns } = props;

	return (
		<Drawer maxWidth="xs" anchor="left" onClose={onClose} open>
			<DialogTitle id="ra-columns-dialog-title">{configurationLabel}</DialogTitle>
			<DialogContent>
				<ColumnSelectionForm
					columns={columns}
					selection={selection}
					onColumnClicked={props.onColumnClicked}
					resource={resource}
					filterColumns={filterColumns} // Pass the filterColumns prop down
				/>
			</DialogContent>
		</Drawer>
	);
};

SelectionDialog.propTypes = {
	columns: T.arrayOf(
		T.shape({
			label: T.string,
			source: T.string.isRequired,
		})
	).isRequired,
	selection: T.object.isRequired,
	onColumnClicked: T.func.isRequired,
	onClose: T.func.isRequired,
	resource: T.string.isRequired,
	configurationLabel: T.string.isRequired,
	filterColumns: T.arrayOf(T.string), // Optional prop
};

SelectionDialog.defaultProps = {
	columns: [],
};
